// Lightweight navigation guard to prevent rapid repeated navigations to the same path
// Uses sessionStorage so the guard survives across route code paths and SSR boundaries
export function canNavigateTo(path: string, windowMs: number = 1000): boolean {
  if (typeof window === 'undefined') return true;

  try {
    const raw = sessionStorage.getItem('__last_navigation');
    const now = Date.now();
    if (raw) {
      const parsed = JSON.parse(raw) as { path: string; ts: number };
      if (parsed.path === path && now - parsed.ts < windowMs) {
        return false;
      }
    }

    sessionStorage.setItem('__last_navigation', JSON.stringify({ path, ts: now }));
    return true;
  } catch {
    // If sessionStorage is unavailable for any reason, be permissive
    return true;
  }
}

export default canNavigateTo;
